export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14231.d8f8e190.jpg";